import React, { useState, useEffect, useRef } from 'react';
import { Layout, Typography, Dropdown } from 'antd';
import Screen1 from './Screen1';
import Screen2 from './Screen2';
import Screen3 from './Screen3';
import Screen4 from './Screen4';
import Screen5 from './Screen5';
import Screen6 from './Screen6';
import AixueFooter from '@/components/AixueFooter/index';
import 'animate.css';
import styles from './index.module.scss';

export default function AixueHome() {

  return (
      <div className={`aixue-home-scroll ${styles.container}`}>
        <Screen1 />
        <Screen2 />
        <Screen3 />
        <Screen4 />
        <Screen5 />
        <Screen6 />
        <div className={styles['footer-snap']}>
          <AixueFooter />
        </div>
    </div>
  );
}
